import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  MadMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { MadIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type MadDocumentAddedActivity = ActivityFragment & {
  recipient: CampaignMinimalFragment;
  trackable: MadMinimalFragment;
};

export function isMadDocumentAddedActivity(
  q: ActivityFragment
): q is MadDocumentAddedActivity {
  return q.key === "mad.document_added";
}

interface MadDocumentAddedActivityProps {
  activity: MadDocumentAddedActivity;
}

export const MadDocumentAddedActivity: React.FC<MadDocumentAddedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="madDocumentAddedActivity"
      visual={<MadIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.madDocumentAdded", {
          mad: (
            <Link to={`/mads/${activity.trackable.id}`} key={activity.id}>
              {t("activity.objects.mad")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
